import { render, staticRenderFns } from "./RelatedMaterialsSidebar.vue?vue&type=template&id=27caff62&lang=true"
import script from "./RelatedMaterialsSidebar.vue?vue&type=script&lang=js"
export * from "./RelatedMaterialsSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports